// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aosc","questions":"styles_questions__3vXPQ","footer":"styles_footer__1bPf2"};